import { CorePagesAbout } from "@dealer-center/core-pages-about";
import { useCC9Flags } from "@dealer-center/core-third-party-launch-darkly";
import { useGetAccount } from "@dealer-center/ddc-api-account-fetch";
import { useGetUser } from "@dealer-center/ddc-api-user-fetch";

export function PagesAbout() {
  const flags = useCC9Flags();
  const { data: userEntity } = useGetUser();
  const { data: accountEntity } = useGetAccount();
  return (
    <CorePagesAbout
      accountEntityJsonString={
        accountEntity && JSON.stringify(accountEntity, null, 2)
      }
      flags={flags}
      rootPath="landing"
      userEntityJsonString={JSON.stringify(userEntity, null, 2)}
    />
  );
}

export default PagesAbout;
